<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div style="float:right">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>

          <el-dropdown-item divided>
            <span @click="editUser" style="display:block;">编辑</span>
          </el-dropdown-item>

          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :title="'编辑用户'" :visible.sync="dialogVisible" width="40%">
      <el-form :model="admin" ref="adminForm" label-width="150px" size="small">
        <el-form-item label="帐号：">
          <el-input v-model="admin.username" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input v-model="admin.nickname" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="手机：">
          <el-input v-model="admin.mobile" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="admin.email" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="密码：">
          <el-input v-model="admin.password" class="input_passWord_250" type="text"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { updateUserInfo } from '@/api2/user'
import { setToken } from '@/utils/auth'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      dialogVisible: false,
      messageList: null,
      linkedAlipay: '',
      admin:{
        username:'',
        email:'',
        mobile:'',
        nickname: '',
        password:''
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
    ])
  },
  created(){
    this.admin = this.$store.state.user.userInfo
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    // 退出登录
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },

    //编辑
    editUser() {
      this.dialogVisible = true;
      // this.isEdit = true;
    },
    
    //确定编辑
    handleDialogConfirm(){
      delete this.admin.id
      delete this.admin.token
      this.admin.methodCode = 'v3.account.update'
      updateUserInfo(this.admin).then((res) =>{
        this.dialogVisible = false;
        let tokenStr = res.data.token
        setToken(tokenStr)
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 64px;
  line-height: 64px;
  border-radius: 0px !important;
  border-bottom: 0;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.04);

  .hamburger-container {
    line-height: 72px;
    height: 64px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 64px;
    display: inline-block;
    position: absolute;
    right: 35px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .orderNum{
    font-size: 14px;
    color: #666;
    float: left;
  }
  .messageTime{
    font-size: 14px;
    color: #666;
    float: right;
  }
  .linkedImg{
    width: 400px;
    height: 423px;
    margin: 0 auto;

    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue